import styled from "styled-components";
import colors from "./Colors";

export const Select = styled.select`
  height: 24px;
  border: none;
  appearance: none;
  color: ${colors.primary};
  font-size: 14px;
`;